module.exports = __webpack_public_path__ + "img/product-m-step.7f519516.png";